import React, { forwardRef, useCallback, useImperativeHandle } from 'react';
import classNames from 'classnames';
import { Modal } from 'ncoded-component-library';
import {
  ModalProps,
  ModalRef,
} from 'ncoded-component-library/build/components/organisms/Modal/Modal.component';
import useCallbackRef from 'hooks/useCallbackRef';
import { isSingleElementArray } from 'utils';
import { useTranslation } from 'react-i18next';
import BroadcastMessageForm from './components/BroadcastMessageForm';
import { ColdLeadAggregationResult } from 'router/subrouters/DataRoom/models/Dashboard';
import { getColdLeadUserInfo } from './utils';

import './BroadcastMessageModal.styles.scss';

type BroadcastMessageModalProps = {
  className?: string;
  dataRoomMembers: Partial<ColdLeadAggregationResult>[];
} & ModalProps;

const BroadcastMessageModal: React.ForwardRefRenderFunction<
  ModalRef,
  BroadcastMessageModalProps
> = (props, ref) => {
  const { className, dataRoomMembers = [], ...rest } = props;

  const [modal, modalRef] = useCallbackRef<ModalRef>();

  useImperativeHandle(ref, () => modal, [modal]);

  const classes = classNames('lead-broadcast-message-modal', className);

  const { t } = useTranslation();

  const isBroadcast = !isSingleElementArray(dataRoomMembers);

  const onCancel = useCallback(() => modal?.close(), [modal]);

  return (
    <Modal
      ref={modalRef}
      className={classes}
      title={t(isBroadcast ? 'broadCastFollowUp' : 'followUpUC')}
      {...rest}
    >
      {modal?.openState && (
        <div className="lead-broadcast-message-modal__content">
          <p>{t('thisMessageWillBeSentToLeadsWithEnquiry')}</p>

          {!isBroadcast && (
            <p className="lead-broadcast-message-modal__sending-to">
              {t('sendingToLead', {
                lead: getColdLeadUserInfo(dataRoomMembers[0]),
              })}
            </p>
          )}

          <BroadcastMessageForm
            dataRoomMembers={dataRoomMembers}
            isBroadcast={isBroadcast}
            onClose={onCancel}
          />
        </div>
      )}
    </Modal>
  );
};

export default forwardRef(BroadcastMessageModal);
